import ApiLaw from "@api/ApiLaw";



export interface ConversationResponse {
  status: string;
  data: {
    updatedAt: string;
    _id: string;
    __v: number;
  };
}

class LawRepo {
  async aiAnswer(query: string, cancelToken?: AbortSignal) {
    const path = '/api/answer'
    return await ApiLaw.GET(path, { query }, {}, cancelToken);
  }

  async aiSearch(query: string, type: 0 | 1 | 2, cancelToken?: AbortSignal) {
    const path = '/api/search'
    return await ApiLaw.GET(path, { query, type }, {}, cancelToken);
  }

  createConversation = async (): Promise<string | null> => {
    try {
      const path = '/api/conversations';
      const data = {};

      const {response} = await ApiLaw.POST(
        path,
        data,
      );

      if (response && response.data && response.data.data && response.data.data._id) {
        const conversationId = response.data.data._id;
        localStorage.setItem("conversationId", conversationId);
        return conversationId;
      }
      return null;
    } catch (error) {
      console.error('Lỗi khi tạo cuộc trò chuyện:', error);
      return null;
    }
  };

  getConversationId = async (): Promise<string | null> => {
    const storedConversationId = localStorage.getItem("conversationId");
    return storedConversationId || null;
  };

  clearConversationId = async (): Promise<void> => {
    localStorage.removeItem("conversationId");
  };

}

export default new LawRepo();